
import { windowatch } from '../../../scripts/lib/windowatch';
import { detect } from 'detect-browser';

export default class VideoHover {
  constructor ($el) {
    this.$el = $el;
    this.$video = $el.querySelector("video");
    this.$teaserboxClassList = $el.parentNode.parentNode.parentNode.classList;
    this.$play = $el.querySelector(".video-hover__btn-play");
    this.$replay = $el.querySelector(".video-hover__btn-replay");
    this.updateHover();

    // Bind button press events
    this.$play.querySelector('.button__inner').addEventListener('click', this.onPlayClick.bind(this));
    this.$replay.querySelector('.button__inner').addEventListener('click', this.onReplayClick.bind(this));

    // Show play button once after load on Mac Safari only.
    let platform = navigator?.userAgentData?.platform || navigator?.platform || 'unknown';
    if (platform !== 'unknown') {
      // See https://stackoverflow.com/a/11752084 for all platforms.
      var isMac = platform.toUpperCase().indexOf('MAC') >= 0;
    }
    const browser = detect();
    if (browser && browser.name == 'safari') {
      var isSafari = true;
    }

    if (isMac && isSafari) {
      this.setPlayButton();
    } else {
      // Set event listeners when not on Mac.
      this.setEventListeners();
    }
  }

  setPlayButton () {
    this.$play.style.display = 'block';
  }

  setEventListeners() {
    // Bind hover video events
    this.$el.addEventListener('mouseover', this.onMouseOver.bind(this));
    this.$el.addEventListener('mouseout', this.onMouseOut.bind(this));

    // Bind scroll and resize events
    windowatch.addScrollListener(this.onScroll.bind(this));
    windowatch.addBreakpointListener(this.onBreakpointChange.bind(this));

    // Might have performance implications?
    document.addEventListener('touchend', this.onScroll.bind(this));

    // Bind video play events
    this.$video.addEventListener('ended', this.onVideoEnded.bind(this));
  }

  onMouseOver (evt) {
    evt.preventDefault();
    if (this.$hoverVdieo) {
      this.playVideo();
    }
  }

  onMouseOut (evt) {
    evt.preventDefault();
    if (this.$hoverVdieo) {
      this.reloadVideo();
    }
  }

  onVideoEnded (evt) {
    evt.preventDefault();
    this.reloadVideo();

    // Show the replay button.
    if (!this.$hoverVdieo) {
      this.$replay.style.display = 'block';
    }
  }

  onPlayClick (evt) {
    evt.preventDefault();
    this.setEventListeners();
    this.playVideo();
  }

  onReplayClick (evt) {
    evt.preventDefault();

    if (!this.$hoverVdieo) {
      this.playVideo();
    }
  }

  onScroll (scroll) {
    if (this.$hoverVdieo == false) {
      var viewportHeight = window.innerHeight;
      var viewportMiddle = viewportHeight / 2;
      var elementPositionTop = this.$el.getBoundingClientRect().top;
      var elementHeight = this.$el.offsetHeight;
      if (elementHeight == 0) {
        elementHeight = this.$el.parentNode.offsetHeight;
      }
      var sliderClass = 'slider__item';
      var activeClass = 'slider__item--active';

      // Play video when top of the element is slightly above the middle of the viewport.
      // If element has sliderClass, it should also have activeClass to play.
      if (
        elementPositionTop < viewportMiddle + (0.5 * elementHeight)
        && elementPositionTop > viewportMiddle - (1 * elementHeight)
        && (this.$teaserboxClassList.contains(sliderClass) === this.$teaserboxClassList.contains(activeClass))
      ) {
        this.playVideo();
      } else {
        this.reloadVideo();
      }
    }
  }

  onBreakpointChange (breakpoint) {
    this.reloadVideo();
    this.updateHover();
  }

  // Video functions.

  // Set $hoverVdieo variable based on the current breakpoint.
  // - True means that we play video on mouse hover.
  // - False means that we play video on viewport position.
  updateHover () {
    const breakpoint = windowatch.getBreakpoint();
    const hoverBreakpoints = ['xl', 'l'];
    if (hoverBreakpoints.includes(breakpoint)) {
      this.$hoverVdieo = true;
    } else {
      this.$hoverVdieo = false;
    }
  }

  playVideo () {
    var isPlaying = this.$video.currentTime > 0 && !this.$video.paused && !this.$video.ended && this.$video.readyState > 2;
    if (!isPlaying) {
      try {
        this.$video.play();
      } catch (err) {
        // Ignore the 'Unhandled Promise Rejection' as it should work with
        // the updated logic.
      } finally {
        if (
          !this.$video.paused
          && !this.$video.ended
        ) {
          this.$play.style.display = 'none';
          this.$replay.style.display = 'none';
        }
      }
    }
  }

  reloadVideo () {
    var isPlaying = this.$video.currentTime > 0 && !this.$video.paused && !this.$video.ended && this.$video.readyState > 2;
    if (isPlaying) {
      try {
        this.$video.load();
      } catch (err) {
        // Ignore the 'Unhandled Promise Rejection' as it should work with
        // the updated logic.
      } finally {
        if (
          this.$video.paused
          || this.$video.ended
        ) {
          this.$replay.style.display = 'none';
        }
      }
    }
  }
}
